module.exports = __webpack_public_path__ + "img/bush(light).ddd39e1.png";